import React from "react";
import { motion } from "framer-motion";
import BookingForm from "../components/BookingForm";
import Testimonials from "../components/Testimonials";
import ServicesOverview from "../components/ServicesOverview";

import bgImage from "../assets/hero-background.jpg";
import "./Home.css";

export default function Home() {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="home-container"
    >
      {/* ✅ HERO SECTION */}
      <section
        className="hero-premium"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          padding: "6rem 2rem",
          color: "white",
          textAlign: "center",
        }}
      >
        <div className="hero-content">
          <motion.h1
            animate={{ y: [50, 0], opacity: [0, 1] }}
            transition={{ duration: 0.5 }}
          >
            Berkinson
          </motion.h1>
          <p>Your Clothes, Our Care</p>
          <button
            onClick={() =>
              document
                .querySelector(".premium-booking-form")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Book a Pickup
          </button>
        </div>
      </section>

      {/* ✅ BOOKING FORM SECTION */}
      <section className="booking-section premium-booking-form">
        <h2>Book a Pickup</h2>
        <BookingForm />
      </section>

      {/* ✅ TESTIMONIALS */}
      <Testimonials />

      {/* ✅ HOW IT WORKS */}
      <ServicesOverview />
    </motion.main>
  );
}
